import { render, staticRenderFns } from "./AddPhotos.vue?vue&type=template&id=151e3cee&scoped=true&"
import script from "./AddPhotos.vue?vue&type=script&lang=js&"
export * from "./AddPhotos.vue?vue&type=script&lang=js&"
import style0 from "./AddPhotos.vue?vue&type=style&index=0&id=151e3cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151e3cee",
  null
  
)

export default component.exports